import React from 'react';
import PropTypes from 'prop-types';
import styles from './ContentCard.module.css';

const ContentCard = ({
  children,
  title,
  subtitle,
  headerActions,
  padding = 'none',
  className = '',
  ...rest
}) => {
  const containerClasses = [
    styles.container,
    styles[`padding-${padding}`],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...rest}>
      {(title || subtitle || headerActions) && (
        <div className={styles.header}>
          <div className={styles.headerContent}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          {headerActions && <div className={styles.headerActions}>{headerActions}</div>}
        </div>
      )}
      <div className={styles.body}>{children}</div>
    </div>
  );
};

ContentCard.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.string,
  headerActions: PropTypes.node,
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default ContentCard;
